import { sb } from '../supabase';

// Admin side of main-image quality (catalog ordering step C, 2026-10-04).
// product_image_quality is readable by admins (RLS) and written only by the
// score-product-images function; the switch lives in admin_settings.

export const IMAGE_QUALITY_SETTING = 'catalog_image_quality_enabled';

// Flags the scorer stores, in the order the list shows them, ar / en.
export const FLAG_LABELS = {
  blurry:              { ar: 'صورة مشوّشة', en: 'Blurry' },
  collage:             { ar: 'كولاج منتجات مختلفة', en: 'Collage of different products' },
  screenshot:          { ar: 'لقطة شاشة', en: 'Screenshot' },
  catalog_page:        { ar: 'صفحة كتالوج مليئة بالنص', en: 'Catalog page full of text' },
  variants:            { ar: 'عدة صور لنفس المنتج', en: 'Variants of one product' },
  not_visible:         { ar: 'المنتج غير واضح', en: 'Product not clearly visible' },
  low_res:             { ar: 'دقة أقل من 300 بكسل', en: 'Under 300 px' },
  text_covers_product: { ar: 'نص فوق المنتج', en: 'Text over the product' },
  watermark:           { ar: 'علامة مائية أو نص', en: 'Watermark / text' },
  soft:                { ar: 'غير حادّة', en: 'Soft focus' },
  cluttered:           { ar: 'خلفية مزدحمة', en: 'Cluttered background' },
  small:               { ar: 'دقة أقل من 600 بكسل', en: 'Under 600 px' },
};

export function flagList(flags) {
  return Object.keys(FLAG_LABELS).filter((k) => flags && flags[k] === true);
}

export async function fetchImageQualitySummary() {
  const { data, error } = await sb.from('product_image_quality').select('status, verdict');
  if (error) throw error;
  const out = { pending: 0, error: 0, good: 0, ok: 0, bad: 0, total: 0 };
  for (const r of data || []) {
    out.total += 1;
    if (r.status === 'scored') out[r.verdict] = (out[r.verdict] || 0) + 1;
    else out[r.status] = (out[r.status] || 0) + 1;
  }
  return out;
}

// Rows with one verdict ('bad', 'ok', 'good') or status ('error'), joined to
// the catalog for name, seller and link.
export async function fetchImageQualityRows(kind, limit = 200) {
  let q = sb.from('product_image_quality')
    .select('source, product_id, image_url, verdict, score, flags, width, height, last_error, checked_at')
    .order('score', { ascending: true, nullsFirst: true }).limit(limit);
  q = kind === 'error' ? q.eq('status', 'error') : q.eq('status', 'scored').eq('verdict', kind);
  const { data: rows, error } = await q;
  if (error) throw error;
  const ids = (rows || []).map((r) => r.product_id);
  let products = [];
  if (ids.length) {
    const res = await sb.from('catalog_products_public')
      .select('id, source, name_ar, name_en, seller_id, seller_name, seller_name_latin').in('id', ids);
    if (res.error) throw res.error;
    products = res.data || [];
  }
  const byKey = new Map(products.map((p) => [`${p.source}:${p.id}`, p]));
  return (rows || []).map((r) => ({ ...r, product: byKey.get(`${r.source}:${r.product_id}`) || null }));
}

export async function requeueImageScore(items) {
  return sb.rpc('admin_requeue_image_score', { p_items: items });
}

export async function readImageQualitySwitch() {
  const { data, error } = await sb.from('admin_settings').select('value').eq('key', IMAGE_QUALITY_SETTING).maybeSingle();
  if (error) throw error;
  return data?.value === true;
}

export async function writeImageQualitySwitch(on, actorId) {
  return sb.from('admin_settings')
    .update({ value: !!on, updated_at: new Date().toISOString(), updated_by: actorId || null })
    .eq('key', IMAGE_QUALITY_SETTING).select('key');
}
